import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e01787d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 pt-3" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Size:", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex item-center justify-start"
}
const _hoisted_5 = { class: "flex items-center justify-between border-solid border-current border-2 rounded pl-1.5 pr-1.5 py-0.5" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "px-10" }
const _hoisted_8 = { class: "px-10 pt-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Color: ")
const _hoisted_11 = {
  key: 0,
  class: "flex item-center justify-start"
}
const _hoisted_12 = { class: "flex items-center justify-between border-solid border-current border-2 rounded pl-1.5 pr-1.5 py-0.5" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "pt-3" }
const _hoisted_15 = { class: "my-2 flex items-center justify-between" }
const _hoisted_16 = { class: "flex items-center justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_BulkUpdate = _resolveComponent("BulkUpdate")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_AddSetCost = _resolveComponent("AddSetCost")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                class: "grid-content text-base font-bold pr-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  (_ctx.sizesValue && _ctx.sizesValue.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesValue, (size, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "pr-1",
                            key: `size-catalog-${index}`
                          }, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(size.name), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_divider)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_row, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                class: "grid-content text-base font-bold pr-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withCtx(() => [
                  (_ctx.colorsValue && _ctx.colorsValue.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorsValue, (color, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "pr-1",
                            key: `color-catalog-${index}`
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(color.name), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, [
            (_ctx.typeInAction.toString() !== 'v,i,e,w')
              ? (_openBlock(), _createBlock(_component_BulkUpdate, {
                  key: 0,
                  selected: _ctx.selectedIds,
                  onSelectedAction: _ctx.onSelectedAction
                }, null, 8, ["selected", "onSelectedAction"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.filterColors,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterColors) = $event)),
              placeholder: "Filter Colors",
              multiple: "",
              filterable: "",
              "allow-create": "",
              clearable: "",
              onChange: _ctx.onSelectFilter,
              class: "mx-1",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorsValue, (color, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: `color-catalog-${index}`,
                    value: color.name
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.filterSizes,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterSizes) = $event)),
              placeholder: "Filter Sizes",
              multiple: "",
              filterable: "",
              "allow-create": "",
              clearable: "",
              onChange: _ctx.onSelectFilter,
              class: "mx-1",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesValue, (size, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: `size-catalog-${index}`,
                    value: size.name
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.variants,
          stripe: "",
          fit: "",
          "default-sort": { prop: 'color', order: 'ascending' },
          style: {"width":"100%"},
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            (_ctx.typeInAction.toString() !== 'v,i,e,w')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  type: "selection",
                  width: "55"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              prop: "catalogVariantCode",
              label: "Variant code"
            }),
            _createVNode(_component_el_table_column, {
              prop: "color",
              label: "Color",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_16, [
                  (scope.row.color.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "w-4 h-4 bg-color-variant mr-1",
                        style: _normalizeStyle(`--color:${scope.row.color.value}`)
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "w-4 h-4 bg-color-variant mr-1",
                        style: _normalizeStyle(`--color:${scope.row.color.name}`)
                      }, null, 4)),
                  _createElementVNode("div", null, _toDisplayString(scope.row.color.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "size",
              label: "Size",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.size.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "desciption",
              label: "Desciption"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cost",
              label: "Cost",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.cost)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Ship US" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "shipUsFirst",
                  label: "First"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipUsFirst)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shipUsAdditional",
                  label: "Additional"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipUsAdditional)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Ship ROW (Rest of world)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "shipRowFirst",
                  label: "First"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipRowFirst)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shipRowAdditional",
                  label: "Additional"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipRowAdditional)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"])
      ])
    ]),
    _createVNode(_component_AddSetCost, {
      ref: "addSetCostDialog",
      selected: _ctx.selectedIds,
      baseCost: _ctx.baseCostId,
      onCallback: _ctx.bulkUpdateCost
    }, null, 8, ["selected", "baseCost", "onCallback"])
  ], 64))
}